var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { mergeRefs } from '../../../../utils';
import { useMultiStyleConfig } from '../../../../utils/use-style-config';
import { Box } from '../../Box';
import { usePopoverContext } from '../basePopover.utils';
import { jsx as _jsx } from "react/jsx-runtime";
// Using `forwardRef` from `React` because the trigger can be any HTML element.
export var BasePopoverTrigger = /*#__PURE__*/React.forwardRef((_ref, triggerRef) => {
  var {
    children
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var {
    refs,
    setIsOpen,
    isOpen,
    triggeredByClick,
    getReferenceProps
  } = usePopoverContext();
  var childrenRef = children.ref;
  var ref = mergeRefs([refs.setReference, triggerRef, childrenRef]);
  var dataState = isOpen ? 'open' : 'closed';
  var sharedProps = {
    ref,
    'data-state': dataState,
    tabIndex: 0
  };

  var handleClick = event => {
    event.stopPropagation();
    triggeredByClick && setIsOpen(!isOpen, 'children');
  };

  var styles = useMultiStyleConfig('BasePopover', {});

  if ( /*#__PURE__*/React.isValidElement(children)) {
    return /*#__PURE__*/React.cloneElement(children, getReferenceProps(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, sharedProps), props), children.props), {}, {
      onClick: event => {
        var _props$onClick, _props;

        handleClick(event);
        (_props$onClick = (_props = children.props).onClick) === null || _props$onClick === void 0 ? void 0 : _props$onClick.call(_props, event);
      }
    })));
  }

  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread(_objectSpread({
    "data-component": props['data-component'],
    as: triggeredByClick ? 'button' : 'span',
    role: triggeredByClick ? undefined : 'button',
    __css: styles['trigger']
  }, sharedProps), getReferenceProps(props)), {}, {
    onClick: handleClick,
    children: children
  }));
});
BasePopoverTrigger.displayName = 'BasePopoverTrigger';
//# sourceMappingURL=BasePopoverTrigger.js.map